export default ({ app, store }) => {
  app.config.globalProperties.$cmsStringParser = (string) => {
    return string.replace(/\{(.*?)\}/g, (match, p1) => {
      if (p1 === 'label') {
        const labeltranslation = store.getters['user/user']?.collectivityLabel?.translation;

        if (!labeltranslation) {
          console.warn('[cmsStringParser] User has no collectivityLabel with translation}');
          return match;
        }

        return labeltranslation;
      }
      console.warn(`[cmsStringParser] Unknown placeholder: ${p1}`);
      return match;
    });
  };
};
